import React, { Fragment, useState, useEffect, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import CreateCounselor from "./CreateCounselor";
import CustomPagination from "../../pagination/Pagination";
import "../AdminPages.css";

const Counselors = () => {
  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [schoolId, setSchoolId] = useState();
  const [pageData, setPageData] = useState();
  const [schoolAdminList, setSchoolAdminList] = useState([]);
  const [counselorList, setCounselorList] = useState([]);
  const [openCreateCounselor, setOpenCreateCounselor] = useState(false);
  const [openModifyCounselor, setOpenModifyCounselor] = useState(false);
  const [modifyData, setModifyData] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    setShowSchoolNameContainer(true);
    setSchoolNameList([]);
    GetAdminService.getSchoolsList(value)
      .then((data) => {
        setSchoolNameList(data?.data?.school);
        setSchoolNameLoading(false);
      })
      .catch(() => {
        setSchoolNameLoading(false);
      });
  };

  const getPageData = (id, p) => {
    setLoading(true);
    let obj = {
      school: id,
      page: 1,
      role: "counselor",
    };
    if (p) obj.page = p;
    GetAdminService.postAdminPage(obj)
      .then((data) => {
        setLoading(false);
        setPageData(data?.data);
        setCounselorList(
          data?.data?.result.filter((item) => item.is_super_counselor === false)
        );
        setSchoolAdminList(
          data?.data?.result.filter((item) => item.is_super_counselor === true)
        );
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
      setCounselorList([]);
      setSchoolAdminList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName(item?.name);
    setSchoolId(item?.id);
    getPageData(item?.id);
  };

  const modifyCounselor = (item) => {
    setLoading(true);
    GetAdminService.getModifyCounselor(item?.id)
      .then((data) => {
        setModifyData(data?.data?.objects);
        setOpenModifyCounselor(true);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (schoolId) {
      getPageData(schoolId, page);
    }
  }, [page]);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Counselors</h2>
              {schoolId && (
                <button
                  className="admin-students-new-btn"
                  onClick={() => setOpenCreateCounselor(true)}
                >
                  <FontAwesomeIcon icon={faUser} />
                  New Counselor
                </button>
              )}
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName}
                  onChange={handleSchoolName}
                  autoComplete="off"
                />
                {showSchoolNameContainer && (
                  <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                      schoolNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedSchoolName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {loading ? (
              <div className="admin-page-section">
                <CustomLoader />
              </div>
            ) : (
              pageData && (
                <div className="admin-students-list-section">
                  <div className="admin-student-list-container">
                    <p className="admin-students-heading">Counselors</p>
                    {counselorList.map((item, index) => (
                      <div
                        key={item?.id || index}
                        className="student-list"
                        onClick={() => modifyCounselor(item)}
                      >
                        <span className="student-email">{item?.email}</span>
                      </div>
                    ))}
                  </div>

                  <div
                    className="admin-student-list-container"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="admin-students-heading">Super Counselors</p>
                    {schoolAdminList.map((item, index) => (
                      <div
                        key={item?.id || index}
                        className="student-list"
                        onClick={() => modifyCounselor(item)}
                      >
                        <span className="student-email">{item?.email}</span>
                      </div>
                    ))}
                  </div>

                  {openModifyCounselor && (
                    <CreateCounselor
                      setOpenCreateCounselor={setOpenModifyCounselor}
                      modify={modifyData}
                      school_id={schoolId}
                      getPageData={getPageData}
                    />
                  )}
                </div>
              )
            )}

            {pageData && pageData?.page_list?.length > 1 && (
              <div className="admin-page-pagination">
                <CustomPagination
                  count={pageData && pageData}
                  pageValue={page}
                  setPage={setPage}
                />
              </div>
            )}

            {openCreateCounselor && (
              <CreateCounselor
                setOpenCreateCounselor={setOpenCreateCounselor}
                modify={false}
                school_id={schoolId}
                getPageData={getPageData}
                school_name={schoolNameList[0]?.name}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Counselors;
